module.exports = __webpack_public_path__ + "static/media/HighLightActive.af1b5a21.png";